import React, { useRef, useEffect, useState } from "react";
import Chart from "chart.js/auto";
import styled from "styled-components";
import { FromUTCEpochToMonthDayString } from "../../../../utils";

interface ICustomChartProps {
  plotData?: any;
  title?: any;
}

const colors = ["rgba(255, 150, 45,1)", "rgb(139, 165, 230)", "rgb(211, 27, 27)", "rgb(24, 195, 81)"];

const AggregateEngagementChart: React.FC<ICustomChartProps> = (props: ICustomChartProps) => {
  const canvasRef: any = useRef("");
  const [chartInstance, setChartInstance]: [any, any] = useState(null);
  console.log("props?.plotData => ", props?.plotData);
  const ToMonthDayLables = (labels: Array<number>) => {
    return labels?.map((epoch: any) => {
      return FromUTCEpochToMonthDayString(epoch);
    });
  };

  useEffect(() => {
    if (props?.plotData) {
      let pDatasets = [];
      let xAxesDateLabels: any = [];
      if (props?.plotData && Object.keys(props?.plotData).length !== 0) {
        let datesWithYear: any = new Set();
        datesWithYear = props?.plotData?.total_opens?.reduce((epochs: Set<string>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, datesWithYear);
        datesWithYear = props?.plotData?.total_clicks?.reduce((epochs: Set<string>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, datesWithYear);
        datesWithYear = props?.plotData?.avg_opens?.reduce((epochs: Set<string>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, datesWithYear);
        datesWithYear = props?.plotData?.avg_clicks?.reduce((epochs: Set<string>, dataset: any) => {
          epochs.add(dataset[0]);
          return epochs;
        }, datesWithYear);

        const xAxesLabels: Array<any> =
          datesWithYear &&
          Array.from(datesWithYear)?.sort((a: any, b: any) => (Date.parse(a) < Date.parse(b) ? -1 : 1));

        const epochsMap = new Map();
        xAxesLabels?.forEach((epoch, index) => {
          epochsMap.set(epoch, index);
        });
        console.log("##epochsMap : ", epochsMap);

        const totalOpens: Array<any> = new Array(xAxesLabels?.length).fill(null);
        const totalClicks: Array<any> = new Array(xAxesLabels?.length).fill(null);
        const avgOpens: Array<any> = new Array(xAxesLabels?.length).fill(null);
        const avgClicks: Array<any> = new Array(xAxesLabels?.length).fill(null);

        props?.plotData?.total_opens?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          totalOpens[ind] = dataset[1];
        });
        props?.plotData?.total_clicks?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          totalClicks[ind] = dataset[1];
        });
        props?.plotData?.avg_opens?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          avgOpens[ind] = dataset[1];
        });
        props?.plotData?.avg_clicks?.forEach((dataset: any) => {
          const epoch: number = dataset[0];
          const ind: number = epochsMap.get(epoch);
          avgClicks[ind] = dataset[1];
        });
        // console.log("###avgClicks => ", avgClicks);
        //xAxis ok

        pDatasets.push({
          label: "a",
          borderColor: colors[0],
          pointBorderColor: colors[0],
          pointBackgroundColor: colors[0],
          pointBorderWidth: 1,
          pointHoverRadius: 3,
          pointHitRadius: 3,
          data: totalOpens,
          pointStyle: "circle",
          spanGaps: true,
          fill: false,
        });
        pDatasets.push({
          label: "b",
          borderColor: colors[1],
          pointBorderColor: colors[1],
          pointBackgroundColor: colors[1],
          pointBorderWidth: 1,
          pointHoverRadius: 2,
          pointHitRadius: 3,
          data: totalClicks,
          pointStyle: "circle",
          spanGaps: true,
          fill: false,
        });
        pDatasets.push({
          label: "c",
          borderColor: colors[2],
          pointBorderColor: colors[2],
          pointBackgroundColor: colors[2],
          pointBorderWidth: 1,
          pointHoverRadius: 2,
          pointHitRadius: 3,
          data: avgOpens,
          pointStyle: "circle",
          spanGaps: true,
          fill: false,
        });
        pDatasets.push({
          label: "d",
          borderColor: colors[3],
          pointBorderColor: colors[3],
          pointBackgroundColor: colors[3],
          pointBorderWidth: 1,
          pointHoverRadius: 2,
          pointHitRadius: 3,
          data: avgClicks,
          pointStyle: "circle",
          spanGaps: true,
          fill: false,
        });

        xAxesDateLabels = xAxesLabels;
      }
      if (canvasRef && canvasRef.current && xAxesDateLabels) {
        const someChart = new Chart(canvasRef.current, {
          type: "line",
          data: {
            labels: xAxesDateLabels,
            datasets: pDatasets,
          },
          options: {
            elements: {
              line: {
                tension: 0.5,
              },
            },
            plugins: {
              tooltip: {
                enabled: false,
                position: "nearest",
              },
              legend: {
                display: true,
                title: {
                  display: false,
                },
                labels: {
                  generateLabels: function (chart) {
                    return [];
                  },
                },
              },
            },
            scales: {
              xAxes: {
                display: false,
              },
              yAxes: {
                display: false,
              },
            },
          },
        });
        setChartInstance(someChart);
        return () => {
          someChart.destroy();
        };
      }
    }
  }, [canvasRef, props?.plotData]);
  console.log(chartInstance);
  return (
    <CanvasContainer>
      <span className={"chart-title"}>{props?.title}</span>
      <canvas ref={canvasRef} id="myChart"></canvas>
      {/* <div className="annotation"></div> */}
    </CanvasContainer>
  );
};

export default AggregateEngagementChart;

const CanvasContainer = styled.div`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px;
  background: #fff;
  background-size: cover;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  padding-top: 35px;
  border-radius: 8px;
  canvas {
    background-color: white;
    height: 345px;
    border-radius: 8px;
    /* offset-x | offset-y | blur-radius | spread-radius | color */
    box-shadow: "0 0 12px -1px rgba(0, 0, 0, 0.12)";
    background-image: "#FFFFFF";
    background-size: cover;
    width: 100%;
    max-width: 100% !important;
    height: 100% !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 7px;
    }
  }
  .annotation {
    position: absolute;
    background-color: #71d2ff;
    border-radius: 6.5px;
    width: 13px;
    height: 204px;
    opacity: 0.74;
    right: 6px;
    bottom: 5px;
  }
  .chart-title {
    position: absolute;
    color: #001823;
    font-size: 18px;
    font-weight: 700;
    top: 5px;
    left: 14px;
  }
`;
